@if (label) {
  <app-control-header
    [label]="label"
    [labelWithColon]="titleWithColon"
    [labelParamsObj]="labelParamsObj"
    [index]="index"
    [required]="required"
    [infoTooltip]="infoTooltip"
    [infoTooltipPlacement]="infoTooltipPlacement"
    [infoTooltipClass]="infoTooltipClass"
  ></app-control-header>
}
<div
  class="colorpicker-input rounded-sm border border-navy-40 w-25 h-5"
  [class.cursor-pointer]="!disabled"
  [style.background]="value"
  [cpDisabled]="disabled"
  [cpPositionRelativeToArrow]="true"
  [cpPosition]="'top-right'"
  [cpOutputFormat]="'hex'"
  [(colorPicker)]="value"
  (colorPickerChange)="onColorChanged($event)"
></div>
